<template>
    <div>

        <config-main-title>
            Cabeçalho Específico
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir Cabeçalho
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhuma cabeçalho identificado.'" 
                icon="fas fa-search"
                :action="'Incluir Cabeçalho'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between hover-bg" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>

                        <span class="badge badge-secondary">#{{ dado.id_cabecalho_laudo }}</span>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div v-else>
                            <span v-if="dado.fl_consulta" title="Consulta/Anamnese">
                                <i class="fa-solid fa-stethoscope fa-fw mr-2"></i>
                            </span>
                            <span v-if="dado.fl_laudo" title="Laudo">
                                <i class="fa-solid fa-notes-medical fa-fw mr-2"></i>
                            </span>
                            <span v-if="dado.fl_receita" title="Receita/Prescrição">
                                <i class="fa-solid fa-prescription fa-fw mr-2"></i>
                            </span>
                            <span v-if="dado.fl_requisicao" title="Requisição">
                                <i class="fa-solid fa-heart-pulse fa-fw mr-2"></i>
                            </span>
                            <span v-if="dado.fl_documento" title="Documento/Relatório">
                                <i class="fa-regular fa-file-lines fa-fw mr-2"></i>
                            </span>
                            <span v-if="dado.fl_atestado" title="Atestado">
                                <i class="fa-solid fa-clipboard-check fa-fw mr-2"></i>
                            </span>
                            <span v-if="dado.fl_espelho_atend" title="Espelho">
                                <i class="fa-solid fa-hospital-user fa-fw mr-2"></i>
                            </span>
                            <span class="badge badge-secondary" v-if="dado.filtros && dado.filtros.length">
                                <i class="fa fa-filter" aria-hidden="true"></i>
                                {{ dado.filtros.length }}
                            </span>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_cabecalho_laudo ? '' : 'Novo' }}
                            Cabeçalho
                            <span class="badge badge-secondary" v-if="item.id_cabecalho_laudo">
                                #{{ item.id_cabecalho_laudo }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    placeholder="Informe o título da fila..."
                                    label="Tïtulo"
                                    :validate="validate"
                                    required
                                    v-model="item.st_titulo" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    label="Observações"
                                    :validate="validate"
                                    v-model="item.st_observacoes" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    type="textarea"
                                    rows="3"
                                    label="Texto do Rodapé"
                                    :validate="validate"
                                    v-model="item.st_texto_rodape" />
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Consulta/Anamnese"
                                    v-model="item.fl_consulta" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Laudo"
                                    v-model="item.fl_laudo" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Atestado"
                                    v-model="item.fl_atestado" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Receita/Prescrição"
                                    v-model="item.fl_receita" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Requisição de Exames"
                                    v-model="item.fl_requisicao" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Documento/Relatório"
                                    v-model="item.fl_documento" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Prescrição/Aplicação"
                                    v-model="item.fl_prescr_aplic" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Espelho de Atendimento"
                                    v-model="item.fl_espelho_atend" />
                            </div>
                            <div class="col col-12 col-md-4" v-if="item.fl_espelho_atend">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Texto do Rodapé no Recibo"
                                    v-model="item.fl_rodape_recibo" />
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Não exibir nome do profissional/assinatura no documento"
                                    :validate="validate"
                                    v-model="item.fl_block_ass" />
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    type="select"
                                    :validate="validate"
                                    placeholder="Padrão"
                                    :optionsList="[
                                        { id: 'E', search: 'Esquerda' },
                                        { id: 'D', search: 'Direita' },
                                        { id: 'C', search: 'Centro' },
                                    ]"
                                    optionsData="id"
                                    v-model="item.st_logo_posicao">
                                    <template v-slot:button-pre>
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" id="basic-addon1">Logo</span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-4" v-if="item.st_logo_posicao == 'E' || item.st_logo_posicao == 'D'">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Posição do Texto ao Lado da Logo"
                                    :validate="validate"
                                    v-model="item.fl_logo_ao_lado" />
                            </div>
                            <template v-if="!item.fl_block_ass">
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Exibir Imagem da Assinatura"
                                        :validate="validate"
                                        v-model="item.fl_exibir_assinatura" />
                                </div>
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        sizing="sm"
                                        placeholder="20..."
                                        type="number"
                                        :validate="validate"
                                        v-model="item.in_ass_altura">
                                        <template v-slot:button-pre>
                                            <div class="input-group-prepend">
                                                <span class="input-group-text" id="basic-addon1">Ass Altura</span>
                                            </div>
                                        </template>
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="basic-addon1">mm</span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                            </template>
                        </div>

                        <div class="row">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    placeholder="..."
                                    type="number"
                                    :validate="validate"
                                    v-model="item.in_altura_logo">
                                    <template v-slot:button-pre>
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" id="basic-addon1">Logo Altura</span>
                                        </div>
                                    </template>
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="basic-addon1">mm</span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-4" v-if="!item.fl_block_ass">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Assinatura apenas no final"
                                    v-model="item.fl_ass_final" />
                            </div>
                            <div class="col col-12 col-md-4" v-if="item.imagem_rodape">
                                <az-input
                                    sizing="sm"
                                    placeholder="20..."
                                    type="number"
                                    :validate="validate"
                                    v-model="item.in_altura_img_rodape">
                                    <template v-slot:button-pre>
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" id="basic-addon1">Img Rodapé Altura</span>
                                        </div>
                                    </template>
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="basic-addon1">mm</span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>

                        <div class="row" v-if="item.fl_espelho_atend">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    label="Nome da Empresa no Espelho"
                                    placeholder="Padrão..."
                                    v-model="item.st_nome_empresa" />
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col col-12 col-md-4">
                                <small class="text-muted">
                                    Logo no Laudo
                                </small>
                                <div v-if="item.id_cabecalho_laudo" class="d-flex">
                                    <az-single-image-loader 
                                        chave="logo"
                                        titulo="Logo" 
                                        :single="true" 
                                        :arquivo="item.logo" 
                                        :parms="{ model_type: 'cabecalhoLaudo', model_id: item.id_cabecalho_laudo, public: true }" 
                                        service="cabecalhos">
                                    </az-single-image-loader>
                                </div>
                            </div>
                            <div class="col col-12 col-md-4">
                                <small class="text-muted">
                                    Imagem Final do Laudo (Ex.: Assinatura)
                                </small>
                                <div v-if="item.id_cabecalho_laudo" class="d-flex">
                                    <az-single-image-loader 
                                        chave="imagem"
                                        titulo="Imagem" 
                                        :single="true" 
                                        :arquivo="item.imagem_final" 
                                        :parms="{ 
                                            model_type: 'cabecalhoLaudo', 
                                            model_id: item.id_cabecalho_laudo,
                                            tipo_especial: 'final'
                                        }" 
                                        service="cabecalhos">
                                    </az-single-image-loader>
                                </div>
                            </div>
                            <div class="col col-12 col-md-4">
                                <small class="text-muted">
                                    Imagem Rodapé
                                </small>
                                <div v-if="item.id_cabecalho_laudo" class="d-flex">
                                    <az-single-image-loader 
                                        chave="rodape"
                                        titulo="Imagem" 
                                        :single="true" 
                                        :arquivo="item.imagem_rodape" 
                                        :parms="{ 
                                            model_type: 'cabecalhoLaudo', 
                                            model_id: item.id_cabecalho_laudo,
                                            tipo_especial: 'rodape'
                                        }" 
                                        service="cabecalhos">
                                    </az-single-image-loader>
                                </div>
                            </div>
                        </div>
                      
                        <div class="row mt-3">
                          <div class="col col-12 col-md-4">
                            <small class="text-muted">
                              Imagem do Topo
                            </small>
                            <div v-if="item.id_cabecalho_laudo" class="d-flex">
                              <az-single-image-loader
                                  chave="cabecalhoTopo"
                                  titulo="Logo"
                                  :single="true"
                                  :arquivo="item.imagem_topo_cabecalho"
                                  :parms="{ 
                                    model_type: 'cabecalhoLaudo',
                                    model_id: item.id_cabecalho_laudo,
                                    tipo_especial: 'cabecalhoTopo'
                                  }"
                                  service="cabecalhos">
                              </az-single-image-loader>
                            </div>
                          </div>
                          <div class="col col-12 col-md-4">
                            <small class="text-muted">
                              Marca D'água
                            </small>
                            <div v-if="item.id_cabecalho_laudo" class="d-flex">
                              <az-single-image-loader
                                  chave="marcaDagua"
                                  titulo="Imagem"
                                  :single="true"
                                  :arquivo="item.imagem_marca_dagua"
                                  :parms="{ 
                                      model_type: 'cabecalhoLaudo', 
                                      model_id: item.id_cabecalho_laudo,
                                      tipo_especial: 'marcaDagua'
                                  }"
                                  service="cabecalhos">
                              </az-single-image-loader>
                            </div>
                          </div>
                          <div class="col col-12 col-md-4">
                            <small class="text-muted">
                              Imagem do Final
                            </small>
                            <div v-if="item.id_cabecalho_laudo" class="d-flex">
                              <az-single-image-loader
                                  chave="rodapeFinal"
                                  titulo="Imagem"
                                  :single="true"
                                  :arquivo="item.imagem_final_rodape"
                                  :parms="{ 
                                    model_type: 'cabecalhoLaudo', 
                                    model_id: item.id_cabecalho_laudo,
                                    tipo_especial: 'rodapeFinal'
                                  }"
                                  service="cabecalhos">
                              </az-single-image-loader>
                            </div>
                          </div>
                        </div>

                      <div class="row mt-3">
                        <div class="col col-12 col-md-4">
                          <small class="text-muted">
                            Imagem do Topo (Específica para Primeira Página)
                          </small>
                          <div v-if="item.id_cabecalho_laudo" class="d-flex">
                            <az-single-image-loader
                                chave="cabecalhoTopoPrimeiraPagina"
                                titulo="Logo"
                                :single="true"
                                :arquivo="item.imagem_topo_cabecalho_primeira_pagina"
                                :parms="{
                                    model_type: 'cabecalhoLaudo',
                                    model_id: item.id_cabecalho_laudo,
                                    tipo_especial: 'cabecalhoTopoPrimeiraPagina'
                                  }"
                                service="cabecalhos">
                            </az-single-image-loader>
                          </div>
                        </div>
                        <div class="col col-12 col-md-4">
                          <small class="text-muted">
                            Imagem do Final (Específica para Primeira Página)
                          </small>
                          <div v-if="item.id_cabecalho_laudo" class="d-flex">
                            <az-single-image-loader
                                chave="rodapeFinalPrimeiraPagina"
                                titulo="Imagem"
                                :single="true"
                                :arquivo="item.imagem_final_rodape_primeira_pagina"
                                :parms="{
                                      model_type: 'cabecalhoLaudo',
                                      model_id: item.id_cabecalho_laudo,
                                      tipo_especial: 'rodapeFinalPrimeiraPagina'
                                  }"
                                service="cabecalhos">
                            </az-single-image-loader>
                          </div>
                        </div>

                        <div class="col col-12 col-md-4" v-if="item.fl_receita">
                            <small class="text-muted">
                                Word Modelo Infusão
                            </small>
                            <div v-if="item.id_cabecalho_laudo" class="d-flex">
                                
                                <button type="button" class="btn btn-sm btn-outline-primary mr-2" title="Anexos" v-if="item.modelo_word" @click="enviar_arquivo_word()">
                                    <i class="fa-solid fa-paperclip"></i>
                                    <span class="badge badge-primary ml-1" v-if="item.modelo_word && item.modelo_word.length">
                                        {{ item.modelo_word.length }}
                                    </span>
                                </button>
                            </div>
                        </div>
                      </div>

                        <!-- Configurações para o Espelho -->
                        <div class="mb-3" v-if="item.fl_espelho_atend && item.js_configs">
                            <az-sub-title title="Configurações do Espelho de Atendimento" />        

                            <div class="form-row">
                                <div class="col col-12 col-md-4">
                                    <az-input 
                                        sizing="sm"
                                        type="select"
                                        icon="fa-solid fa-table-columns"
                                        placeholder="Colunas quando sem valor"
                                        :optionsList="[
                                            { id: '1', search: '1 coluna' }, 
                                            { id: '2', search: '2 colunas' }, 
                                            { id: '3', search: '3 colunas' }, 
                                            { id: '4', search: '4 colunas' }, 
                                        ]"
                                        optionsData="id"
                                        v-model="item.js_configs.espelho_cols" />
                                </div>

                                <div class="col col-12 col-md-4">
                                    <az-input 
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Numerar Linhas"
                                        v-model="item.js_configs.espelho_numerar_linhas" />
                                </div>

                                <div class="col col-12 col-md-4">
                                    <az-input 
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Endereço da Unidade no Rodapé"
                                        v-model="item.js_configs.espelho_endereco_rodape" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        sizing="sm"
                                        label="Tamanho Fonte Espelho"
                                        placeholder="Padrão..."
                                        type="number"
                                        :min="6"
                                        :max="32"
                                        v-model="item.js_configs.espelho_tamanho_fonte">
                                    </az-input>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12">
                                    <az-input   
                                        label="Texto do Rodapé do Espelho"
                                        sizing="sm"
                                        type="textarea"
                                        rows="3"
                                        v-model="item.js_configs.espelho_rodape" />
                                </div>
                            </div>
                        </div>

                        <!-- Campos do Cabeçalho -->
                        <az-sub-title title="Campos do Cabeçalho" />
                        <az-input 
                            sizing="sm"
                            type="checkbox-group"
                            label="Definir campos do cabeçalho"
                            v-model="item.fl_campos_cabecalho" />

                        <template v-if="item && item.fl_campos_cabecalho">

                            <lista-campos-cabecalho 
                                nome_campo="js_campos_cabecalho" 
                                :item="item" />

                            <!-- 
                            <div class="form-row" v-for="(campo, icx) in item.js_campos_cabecalho" :key="icx">
                                <div class="col col-12" :class="campo.campo == 'campo' ? 'col-md-2' : 'col-md-4'">
                                    <az-input
                                        type="select"
                                        :optionsList="item.campos_disponiveis"
                                        optionsData="id"
                                        sizing="sm"
                                        :label="icx ? '' : 'Campo'"
                                        v-model="campo.campo">
                                        <template v-slot:button-pre>
                                            <div class="input-group-prepend">
                                                <button type="button" class="btn btn-outline-danger" @click="remover_campo(item, icx)">
                                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-2" v-if="campo.campo == 'campo'">
                                    <az-input
                                        sizing="sm"
                                        :label="icx ? '' : 'Campo'" 
                                        placeholder="Id do Campo..."
                                        v-model="campo.hashtag" />
                                </div>
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        sizing="sm"
                                        :label="icx ? '' : 'Título'" 
                                        placeholder="Título..."
                                        v-model="campo.titulo" />
                                </div>
                                <div class="col col-12 col-md-1">
                                    <az-input
                                        sizing="sm"
                                        :label="icx ? '' : 'Linha'" 
                                        type="number"
                                        v-model="campo.linha" />
                                </div>
                                <div class="col col-12 col-md-1">
                                    <az-input
                                        sizing="sm"
                                        :label="icx ? '' : 'Ordem'" 
                                        type="number"
                                        v-model="campo.ordem" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        :label="icx ? '' : 'Largura (%)'" 
                                        type="number"
                                        v-model="campo.largura" />
                                </div>
                            </div>

                            <button type="button" class="btn btn-sm btn-primary" @click="incluir_campo(item)">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                            </button>
                            -->

                            <!-- Campos da Primeira página -->
                            <az-sub-title title="Campos Apenas da Primeira Página" class="mt-3" />
                            <lista-campos-cabecalho 
                                nome_campo="js_campos_pag_1" 
                                :item="item" />

                        </template>

                        <az-sub-title class="mt-3" title="Papel, Tamanhos e Margens" />

                        <div class="form-row">
                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    placeholder="Padrão..."
                                    label="Papel"
                                    type="select"
                                    :optionsList="[
                                        { id: 'A4', search: 'A4' },
                                        { id: 'A4-T', search: 'A4 (Timbrado)' }, 
                                        { id: 'A4-NT', search: 'A4 (Não Timbrado)' },
                                        { id: 'A5', search: 'A5' }, 
                                        { id: 'A5-T', search: 'A5 (Timbrado)' },
                                        { id: 'A5-NT', search: 'A5 (Não Timbrado)' }, 
                                    ]"
                                    optionsData="id"
                                    v-model="item.st_papel" />
                            </div>

                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    label="Tamanho Fonte Cabeçalho"
                                    placeholder="Padrão..."
                                    type="select"
                                    :validate="validate"
                                    :optionsList="[
                                        { id: '14', search: '14' }, 
                                        { id: '13', search: '13' }, 
                                        { id: '12', search: '12' }, 
                                        { id: '11', search: '11' }, 
                                        { id: '10', search: '10' }, 
                                        { id: '9', search: '9' }, 
                                        { id: '8', search: '8' }, 
                                        { id: '7', search: '7' }, 
                                        { id: '6', search: '6' }, 
                                    ]"
                                    optionsData="id"
                                    v-model="item.in_cabec_tamanho_fonte">
                                </az-input>
                            </div>

                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    label="Tamanho Fonte Rodapé"
                                    placeholder="Padrão..."
                                    type="select"
                                    :validate="validate"
                                    :optionsList="[
                                        { id: '14', search: '14' }, 
                                        { id: '13', search: '13' }, 
                                        { id: '12', search: '12' }, 
                                        { id: '11', search: '11' }, 
                                        { id: '10', search: '10' }, 
                                        { id: '9', search: '9' }, 
                                        { id: '8', search: '8' }, 
                                        { id: '7', search: '7' }, 
                                        { id: '6', search: '6' }, 
                                    ]"
                                    optionsData="id"
                                    v-model="item.in_rodape_tamanho_fonte">
                                </az-input>
                            </div>

                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    label="Tamanho Fonte da Assinatura"
                                    placeholder="Padrão..."
                                    type="select"
                                    :validate="validate"
                                    :optionsList="[
                                        { id: '14', search: '14' }, 
                                        { id: '13', search: '13' }, 
                                        { id: '12', search: '12' }, 
                                        { id: '11', search: '11' }, 
                                        { id: '10', search: '10' }, 
                                        { id: '9', search: '9' }, 
                                        { id: '8', search: '8' }, 
                                        { id: '7', search: '7' }, 
                                        { id: '6', search: '6' }, 
                                    ]"
                                    optionsData="id"
                                    v-model="item.st_ass_fonte_tamanho">
                                </az-input>
                            </div>
                        </div>

                        <!-- A4 -->
                        <div class="form-row">
                            <div class="col col-12 col-md-3">
                                <az-input
                                sizing="sm"
                                placeholder="Padrão..."
                                label="A4 Margem Superior (cm)"
                                type="number"
                                v-model="item.in_margem_superior_a4"
                                />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                sizing="sm"
                                placeholder="Padrão..."
                                label="A4 Margem Inferior (cm)"
                                type="number"
                                v-model="item.in_margem_inferior_a4"
                                />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                sizing="sm"
                                placeholder="Padrão..."
                                label="A4 Margem Esquerda (cm)"
                                type="number"
                                v-model="item.in_margem_esquerda_a4"
                                />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                sizing="sm"
                                placeholder="Padrão..."
                                label="A4 Margem Direita (cm)"
                                type="number"
                                v-model="item.in_margem_direita_a4"
                                />
                            </div>
                        </div>

                        <!-- A5 -->
                        <div class="form-row">
                            <div class="col col-12 col-md-3">
                                <az-input
                                sizing="sm"
                                placeholder="Padrão..."
                                label="A5 Margem Superior (cm)"
                                type="number"
                                v-model="item.in_margem_superior_a5"
                                />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                sizing="sm"
                                placeholder="Padrão..."
                                label="A5 Margem Inferior (cm)"
                                type="number"
                                v-model="item.in_margem_inferior_a5"
                                />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                sizing="sm"
                                placeholder="Padrão..."
                                label="A5 Margem Esquerda (cm)"
                                type="number"
                                v-model="item.in_margem_esquerda_a5"
                                />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                sizing="sm"
                                placeholder="Padrão..."
                                label="A5 Margem Direita (cm)"
                                type="number"
                                v-model="item.in_margem_direita_a5"
                                />
                            </div>
                        </div>

                      <div class="form-row">
                        <div class="col col-12 col-md-3">
                          <az-input
                              sizing="sm"
                              placeholder="Padrão..."
                              label="Início Corpo do Documento (mm)"
                              type="number"
                              v-model="item.in_inicio_corpo"
                          />
                        </div>
                        <div class="col col-12 col-md-3">
                          <az-input
                              sizing="sm"
                              placeholder="Padrão..."
                              label="Final Corpo do Documento (mm)"
                              type="number"
                              v-model="item.in_fim_corpo"
                          />
                        </div>
                      </div>


                      <!-- Filtros -->
                        <filtro-model class="mt-3" v-model="item.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" />

                        <br><br><br>
                        
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="cabecalhoLaudo" :id="item.id_cabecalho_laudo" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_cabecalho_laudo ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Envio de Arquivo -->
        <template v-if="item && item.id_cabecalho_laudo">
            <az-file-upload
                ref="upload"
                @refresh="refresh_arquivos_word"
                :arquivos="item.modelo_word"
                :parms="{ model_type: 'cabecalhoLaudo', model_id: item.id_cabecalho_laudo, tipo_especial: 'word' }" />
        </template>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from './shared/ConfigMainTitle.vue';
import AzInput from '../shared/forms/AzInput.vue';
import AzEmptyState from '../util/AzEmptyState.vue';
import AzSubmit from '../util/AzSubmit.vue';
import AzAuditLogButton from '../util/AzAuditLogButton.vue';
import FiltroModel from './shared/FiltroModel.vue';
import AzSingleImageLoader from '../util/AzSingleImageLoader.vue';
import AzFileUpload from "../util/AzFileUpload.vue";
import AzSubTitle from '../util/AzSubTitle.vue';
import ListaCamposCabecalho from './ListaCamposCabecalho.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            status_para_incluir: "", 
        }
    },

    props: ['cadastro'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        FiltroModel,
        AzSingleImageLoader, 
        AzSubTitle, 
        AzFileUpload, 
        ListaCamposCabecalho, 
    },

    computed: { 
        lista_filtros: function () { 

            if ( !this.item ) 
                return [];

            return this.item.filtros.filter(item => !item.excluido);

        },

        lista: function () { 
            let reg = this.$util.getregex(this.search);
            
            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

        lista_opcoes_filtro: function () { 
            let opcoes = [                                
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index'}, 
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
            ];
            
            if ( this.$store.state.unidade.unidade_operacaos.length > 1 ) { 
                opcoes.push({id:'App\\azure\\unidadeOperacao', search:'Unidade',service:'unidade_operacaos.index'});
            }
            
            return _.orderBy(opcoes, 'search');
        },
    },

    methods: { 
        enviar_arquivo_word() {
            this.$refs.upload.abrir();
        },

        refresh_arquivos_word() { 
            this.load();
            this.$util.loadItem(this, { 
                service: 'cabecalhos',
                func: 'show',
                id: this.item.id_cabecalho_laudo,
            })
            .then(res => { 
                this.item.modelo_word = res.modelo_word;
            })
            .finally(() => { 
                this.$store.commit('loading', false);
            });
        },

        remover_campo(item, idx) { 
            item.js_campos_cabecalho.splice(idx, 1);
        },

        incluir_campo(item) { 
            if ( !item.js_campos_cabecalho )
                item.js_campos_cabecalho = [];

            item.js_campos_cabecalho.push({ 
                campo: "", 
                titulo: "",
                linha: 1,
                largura: 100, 
            });
        },

        serviceFiltro(model) {
            switch (model) {
                case 'App\\azure\\medico': return 'medicos.index';
                case 'App\\azure\\unidadeOperacao': return 'unidade_operacaos.index';
                case 'App\\azure\\operadora': return 'operadoras.index';
                case 'App\\azure\\procedimento': return 'procedimentos.index';
            }
            return null;
        },

        incluir_filtro(item) { 
            item.filtros.push({ 
                id_cabecalho_laudo_filtro: null, 
                model_type: "",
                model_id: "",
                model: "", 
                service: "", 
                fl_regra: true, 
                excluido: false, 
            });
        },
        incluir () { 
            this.validate = false;
            
            let item = {
                st_titulo: "", 
                fl_ativo: true,
                st_observacoes: "", 
                st_texto_rodape: "",
                filtros: [],
                fl_campos_cabecalho: false,
                js_campos_cabecalho: [], 
                fl_logo_ao_lado: false, 
                st_logo_posicao: "", 
                fl_exibir_assinatura: false, 
                fl_ass_final: false,
                in_ass_altura: "", 
                st_ass_fonte_tamanho: "", 
                in_cabec_tamanho_fonte: "", 
                in_rodape_tamanho_fonte: "", 
                fl_atestado: false, 
                fl_laudo: true, 
                fl_consulta: true, 
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service:'cabecalhos',
                func: 'index',
                parms: { 
                    cadastro: true, 
                }
            });
        },
        editar (item) { 
            if ( this.$store.state.loading ) { 
                this.$toast.add({
                    severity: "warn",
                    summary: "Aguarde",
                    detail: "Recarregando...",
                    life: 3000
                });
                return;
            }

            this.item = null;
            this.validate = false;

            this.$nextTick(() => { 
                this.item = _.cloneDeep (item);
    
                if ( !this.item.js_campos_cabecalho )
                    this.item.js_campos_cabecalho = [];
    
                $('#edicaoModal').modal('show');
            });
        },
        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'cabecalhos',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        fechar () { 
            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'cabecalhos',
                dados: item,
            });

        },
        format (n) { 
            let formatter = new Intl.NumberFormat('pt-Br', {
                style: 'currency',
                currency: 'BRL',
                currencyDisplay: 'code',
            });

            return formatter.format(n).substr(4);
        },
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Cabeçalhos Específicos", method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>